import React, { useEffect, useState, useCallback } from 'react';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import exportFromJSON from 'export-from-json';
import * as XLSX from "xlsx"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX, faFolder, faCog, faSignOutAlt, faBars, faUserCircle, faBuilding, faChevronRight, faChevronLeft, faCalendarAlt, faEye, faFilter, faBalanceScale, faColumns, faArrowsLeftRight, faRightL, faChartBareft, faChartBar, faRightLeft, faChartPie } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

import {
    convertNumberIntToDecimal, exportMultipleChartsToPdf, formatDate, formatDate4, formatDate5, getOrDeleteRequest, getSession, postOrPutRequest, serializeExportData
} from '../utils/utils';
import SelectMultiple from '../components/SelectMultiple';
import ChartComponent from '../components/ChartComponent/ChartComponent';
import { usePanel } from '../components/PanelContext/PanelContext';

const MainThemeLayout = ({ children, cards, data = [], load }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { idCompany, idProject } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const [companies, setCompanies] = useState([]);

    const { isPanelVisible, togglePanelVisibility } = usePanel();

    const [panel, setPanel] = useState(false);
    const [reports, setReports] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showFiltersMobile, setShowFiltersMobile] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [userInfo, setUserInfo] = useState({
        userName: "",
        role: "",
        company: "",
    });
    const [projects, setProjects] = useState([]);
    const [resultsGrouped, setResultsGrouped] = useState([]);
    const [filters, setFilters] = useState({
        sectors: [],
        companyTypes: [],
        states: [],
        cities: [],
        districts: []
    });

    const [tempDateType, setTempDateType] = useState('single');
    const [tempSelectedMonth, setTempSelectedMonth] = useState('');
    const [tempSelectedYear, setTempSelectedYear] = useState('');
    const [tempRangeStartMonth, setTempRangeStartMonth] = useState('');
    const [tempRangeStartYear, setTempRangeStartYear] = useState('');
    const [tempRangeEndMonth, setTempRangeEndMonth] = useState('');
    const [tempRangeEndYear, setTempRangeEndYear] = useState('');

    const [activeDateType, setActiveDateType] = useState('single');
    const [activeDateParams, setActiveDateParams] = useState({});
    const [tempSectorId, setTempSectorId] = useState('');
    const [tempCompanyTypeId, setTempCompanyTypeId] = useState('');
    const [tempStateId, setTempStateId] = useState('');
    const [tempCityId, setTempCityId] = useState('');
    const [tempDistrictId, setTempDistrictId] = useState('');

    const [activeFilters, setActiveFilters] = useState({});

    const [fileName, setFileName] = useState(null);

    const getRibbon = async () => {
        let response = await getOrDeleteRequest(
            `ribbon/filter`,
            'GET',
            null,
            false
        );
        if (response.type === 'success') {
            if (response.data.length > 0) {
                const images = response.data
                    .filter((item) => item.place === 'Sistema Inicio')
                    .map((item) => item.image)

                setFileName(images.length > 0 ? images[0] : null);
            } else {
                setFileName(null);
            }
            return;
        }
    };

    useEffect(() => {
        if (!load) return;
        const getValidParam = (param) => {
            const value = searchParams.get(param);
            return value && value.trim() !== '' ? value : '';
        };

        const dateSelect = getValidParam('date_select');
        const dateStart = getValidParam('date_start');
        const dateEnd = getValidParam('date_end');
        const type = getValidParam('date_type') || 'single';
        const sectorId = getValidParam('sector_id');
        const companyTypeId = getValidParam('company_type_id');
        const stateId = getValidParam('state_id');
        const cityId = getValidParam('city_id');
        const districtId = getValidParam('district_id');

        setActiveDateType(type);
        setTempDateType(type);

        if (type === 'single' && dateSelect) {
            const [year, month] = dateSelect.split('-');
            setTempSelectedYear(year);
            setTempSelectedMonth(month);
            setActiveDateParams({
                date_select: `${year}-${month}-01`
            });
        } else if (type === 'range') {
            if (dateStart) {
                const [startYear, startMonth] = dateStart.split('-');
                setTempRangeStartYear(startYear);
                setTempRangeStartMonth(startMonth);
            }
            if (dateEnd) {
                const [endYear, endMonth] = dateEnd.split('-');
                setTempRangeEndYear(endYear);
                setTempRangeEndMonth(endMonth);
            }
            setActiveDateParams({
                date_start: dateStart ? `${dateStart}-01` : '',
                date_end: dateEnd ? `${dateEnd}-01` : ''
            });
        }

        setTempSectorId(sectorId);
        setTempCompanyTypeId(companyTypeId);
        setTempStateId(stateId);
        setTempCityId(cityId);
        setTempDistrictId(districtId);
        setActiveFilters({
            sector_id: sectorId,
            company_type_id: companyTypeId,
            state_id: stateId,
            city_id: cityId,
            district_id: districtId
        });
    }, [searchParams]);

    const generateYears = useCallback(() => {
        const currentYear = new Date().getFullYear();
        return Array.from({ length: 10 }, (_, i) => currentYear - i);
    }, []);

    const months = [
        { value: '01', label: 'Enero' }, { value: '02', label: 'Febrero' },
        { value: '03', label: 'Marzo' }, { value: '04', label: 'Abril' },
        { value: '05', label: 'Mayo' }, { value: '06', label: 'Junio' },
        { value: '07', label: 'Julio' }, { value: '08', label: 'Agosto' },
        { value: '09', label: 'Septiembre' }, { value: '10', label: 'Octubre' },
        { value: '11', label: 'Noviembre' }, { value: '12', label: 'Diciembre' }
    ];

    const formatDateForBackend = (year, month) => {
        return year && month ? `${year}-${month}-01` : '';
    };

    const loadFilterOptions = useCallback(async () => {
        const session = getSession();
        if (!session) return;

        try {
            if ([1, 6].includes(getSession()?.type_id)) {
                const sectorsResponse = await getOrDeleteRequest('business_sectors/filter', 'GET');
                if (sectorsResponse.type === 'success') {
                    setFilters(prev => ({
                        ...prev,
                        sectors: sectorsResponse.data
                    }));
                }

                const companyTypesResponse = await getOrDeleteRequest('company-type/filter', 'GET');
                if (companyTypesResponse.type === 'success') {
                    setFilters(prev => ({
                        ...prev,
                        companyTypes: companyTypesResponse.data
                    }));
                }

                const statesResponse = await getOrDeleteRequest('states/filter', 'GET');
                if (statesResponse.type === 'success') {
                    setFilters(prev => ({
                        ...prev,
                        states: statesResponse.data
                    }));
                }
            }

            if (tempStateId && [1, 6].includes(getSession()?.type_id)) {
                const citiesResponse = await getOrDeleteRequest(`cities/by-state/${tempStateId}`, 'GET');
                if (citiesResponse.type === 'success') {
                    setFilters(prev => ({
                        ...prev,
                        cities: citiesResponse.data
                    }));
                }
            }

            if (tempCityId && [1, 6].includes(session.type_id)) {
                const districtsResponse = await getOrDeleteRequest(`districts/by-city/${tempCityId}`, 'GET');
                if (districtsResponse.type === 'success') {
                    setFilters(prev => ({
                        ...prev,
                        districts: districtsResponse.data
                    }));
                }
            }
        } catch (error) {
            console.error('Error loading filter options:', error);
        }
    }, [tempStateId, tempCityId]);

    useEffect(() => {
        if (!load) return;
        loadFilterOptions();
    }, [loadFilterOptions]);

    const loadExportData = useCallback(async () => {
        // console.log("Loading export data for project:", idProject);

        if (!idProject) return;

        let uri = `report-details/by-project/${idProject}`;

        let response = await getOrDeleteRequest(
            uri,
            'GET',
            null,
            false
        );
        // console.log('Export data response:', response);
        if (response.type === 'success') {
            let dataForExport = serializeExportData(response.data);
            // console.log('Data prepared for export:', dataForExport);
            let dashboardData = JSON.parse(localStorage.getItem('dashboardToProject')) || {};
            localStorage.setItem('dashboardToProject', JSON.stringify(dataForExport));
            return;
        }

        localStorage.setItem('dashboardToProject', JSON.stringify({}));
        return;
    }, []);

    const loadDashboardData = useCallback(async () => {
        setLoading(true);
        const session = getSession();
        if (!session) return;

        try {
            if ([1, 4, 6].includes(session.type_id)) {
                const projectsUri = [1, 2, 3, 6].includes(session.type_id)
                    ? 'projects/filter'
                    : `projects/projectbycompany/${session.company.id}`;

                const projectsResponse = await getOrDeleteRequest(projectsUri, 'GET');
                if (projectsResponse.type === 'success') {
                    setProjects(projectsResponse.data);
                }
            }

            const companyResponse = await getOrDeleteRequest('company/filter', 'GET');
            if (companyResponse.type === 'success') {
                setCompanies(companyResponse.data.length > 0 ? companyResponse.data.map((item) => {
                    return {
                        id: item.id,
                        name: `${item.company_name} ${item.trade_name ? `(${item.trade_name})` : ''}`,
                    }
                }) : []);
            }

            let reportsUri = [1, 6].includes(session.type_id)
                ? `reports/list-report/admin/${session.id}?page=1&limit=5`
                : `reports/list-report/admin/${session.type_id === 4 ? session.id : session.company.user_id}?page=1&limit=5&company_id=${session.company.id}`;

            if (idProject) reportsUri += `&project_id=${idProject}`;

            const queryParams = new URLSearchParams();

            if (activeDateParams.date_select) {
                queryParams.append('date_select', activeDateParams.date_select);
            }
            if (activeDateParams.date_start) {
                queryParams.append('date_start', activeDateParams.date_start);
            }
            if (activeDateParams.date_end) {
                queryParams.append('date_end', activeDateParams.date_end);
            }

            if ([1, 6].includes(session.type_id)) {
                if (activeFilters.sector_id) queryParams.append('sector_id', activeFilters.sector_id);
                if (activeFilters.company_type_id) queryParams.append('company_type_id', activeFilters.company_type_id);
                if (activeFilters.state_id) queryParams.append('state_id', activeFilters.state_id);
                if (activeFilters.city_id) queryParams.append('city_id', activeFilters.city_id);
                if (activeFilters.district_id) queryParams.append('district_id', activeFilters.district_id);
            }

            const reportsResponse = await getOrDeleteRequest(reportsUri, 'GET');
            // console.log('reportsResponse', reportsResponse);
            if (reportsResponse.type === 'success') {
                setReports(reportsResponse.data.data);
            }

            let indicatorsUri = [1, 2, 3, 6].includes(session.type_id)
                ? 'dashboard/indicator-statics'
                : `dashboard/indicators-by-company/${session.type_id === 4 ? session.id : session.company.user_id}`;

            if (idProject) {
                indicatorsUri += `?project_id=${idProject}`;
            }

            if (queryParams.toString()) {
                indicatorsUri += idProject ? `&${queryParams.toString()}` : `?${queryParams.toString()}`;
            }

            const indicatorsResponse = await getOrDeleteRequest(indicatorsUri, 'GET');
            if (indicatorsResponse.type === 'success') {
                setResultsGrouped(indicatorsResponse.results_grouped || indicatorsResponse.data || {});

                let dashboardData = JSON.parse(localStorage.getItem('dashboardData')) || {};
                let central = dashboardData.central || {};
                localStorage.setItem('dashboardData', JSON.stringify({
                    central: central,
                    right: indicatorsResponse.results_grouped || indicatorsResponse.data || {},
                }));
            }

            await loadExportData();
        } catch (error) {
            console.error('Error loading dashboard data:', error);
        } finally {
            setLoading(false);
        }
    }, [idProject, activeDateParams, activeFilters]);

    useEffect(() => {
        if (!load) return;
        loadDashboardData();
    }, [loadDashboardData]);

    useEffect(() => {
        if (!load) return;
        const loadDataWithParams = async () => {
            await loadDashboardData();
        };

        loadDataWithParams();
    }, [idProject, searchParams]);

    const handleStateChange = async (stateId) => {
        setTempStateId(stateId);
        setTempCityId('');
        setTempDistrictId('');

        if (stateId && [1, 6].includes(getSession()?.type_id)) {
            const citiesResponse = await getOrDeleteRequest(`cities/by-state/${stateId}`, 'GET');
            if (citiesResponse.type === 'success') {
                setFilters(prev => ({
                    ...prev,
                    cities: citiesResponse.data,
                    districts: []
                }));
            }
        } else {
            setFilters(prev => ({
                ...prev,
                cities: [],
                districts: []
            }));
        }
    };

    const handleCityChange = async (cityId) => {
        setTempCityId(cityId);
        setTempDistrictId('');

        const session = getSession();
        if (cityId && [1, 6].includes(session?.type_id)) {
            const districtsResponse = await getOrDeleteRequest(`districts/by-city/${cityId}`, 'GET');
            if (districtsResponse.type === 'success') {
                setFilters(prev => ({
                    ...prev,
                    districts: districtsResponse.data
                }));
            }
        } else {
            setFilters(prev => ({
                ...prev,
                districts: []
            }));
        }
    };

    useEffect(() => {
        if (location.pathname === "/PanelDeControl" || location.pathname.startsWith("/PanelDeControlProyecto/")) {
            setPanel(true);
        } else {
            setPanel(false);
        }
    }, [location.pathname]);

    const loadUserData = useCallback(() => {
        const session = getSession();
        if (!session) return;

        let userRole = "No especificado";
        if (session.type_id === 1 || session.type_id === 6) userRole = "Administrador";
        if (session.type_id === 4) userRole = "Organización";

        setUserInfo({
            userName: session.type_id === 4 ? session?.company.company_name : session.username,
            role: userRole,
            company: session.type_id === 4 ? session.company_name : "No aplica"
        });
    }, []);

    const handleLogout = async () => {
        const response = await postOrPutRequest('auth/logout', 'POST', {});

        if (response.type === 'success') {
            Cookies.remove(process.env.REACT_APP_TOKEN);
            Cookies.remove(process.env.REACT_APP_USER);

            Swal.fire({
                title: 'Sesión cerrada',
                text: response.message,
                icon: 'success',
                confirmButtonText: 'Aceptar',
                timer: 3000
            }).then(() => {
                window.location.href = '/';
            });
        } else {
            Swal.fire({
                title: 'Error!',
                text: response.message,
                icon: 'error',
                confirmButtonText: 'Aceptar',
            });
        }
    };

    const applyDateFilters = () => {
        const params = {};
        const session = getSession();
        const isAdmin = session && [1, 6].includes(session.type_id);

        const addParamIfValid = (key, value) => {
            if (value !== undefined && value !== null && value !== '') {
                params[key] = value;
            }
        };

        if (tempDateType === 'single') {
            addParamIfValid('date_type', 'single');
            if (tempSelectedMonth && tempSelectedYear) {
                const dateSelect = `${tempSelectedYear}-${tempSelectedMonth}`;
                addParamIfValid('date_select', dateSelect);
                setActiveDateParams({
                    date_select: formatDateForBackend(tempSelectedYear, tempSelectedMonth)
                });
            }
        } else if (tempDateType === 'range') {
            addParamIfValid('date_type', 'range');

            if (tempRangeStartYear && tempRangeStartMonth) {
                const dateStart = `${tempRangeStartYear}-${tempRangeStartMonth}`;
                addParamIfValid('date_start', dateStart);
            }

            if (tempRangeEndYear && tempRangeEndMonth) {
                const dateEnd = `${tempRangeEndYear}-${tempRangeEndMonth}`;
                addParamIfValid('date_end', dateEnd);
            }

            setActiveDateParams({
                date_start: formatDateForBackend(tempRangeStartYear, tempRangeStartMonth),
                date_end: formatDateForBackend(tempRangeEndYear, tempRangeEndMonth)
            });
        }

        if (isAdmin) {
            addParamIfValid('sector_id', tempSectorId);
            addParamIfValid('company_type_id', tempCompanyTypeId);
            addParamIfValid('state_id', tempStateId);
            addParamIfValid('city_id', tempCityId);
            addParamIfValid('district_id', tempDistrictId);
        }

        setActiveDateType(tempDateType);
        setActiveFilters({
            sector_id: tempSectorId,
            company_type_id: tempCompanyTypeId,
            state_id: tempStateId,
            city_id: tempCityId,
            district_id: tempDistrictId
        });

        let targetUrl = idProject ? `/PanelDeControlProyecto/${idProject}` : '/PanelDeControl';

        const queryParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                queryParams.append(key, value);
            }
        });

        navigate(`${targetUrl}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`);
    };

    const handleProjectChange = (projectId) => {
        if (projectId === idProject) return;

        const currentParams = new URLSearchParams();
        const validParams = ['date_type', 'date_select', 'date_start', 'date_end',
            'sector_id', 'company_type_id', 'state_id', 'city_id', 'district_id'];

        validParams.forEach(param => {
            const value = searchParams.get(param);
            if (value && value.trim() !== '') {
                currentParams.append(param, value);
            }
        });

        const targetUrl = projectId ? `/PanelDeControlProyecto/${projectId}` : '/PanelDeControl';
        navigate(`${targetUrl}${currentParams.toString() ? `?${currentParams.toString()}` : ''}`);
    };

    const clearFilters = () => {
        setTempSelectedMonth('');
        setTempSelectedYear('');
        setTempRangeStartMonth('');
        setTempRangeStartYear('');
        setTempRangeEndMonth('');
        setTempRangeEndYear('');
        setTempDateType('single');
        setActiveDateParams({});
        setActiveDateType('single');

        setTempSectorId('');
        setTempCompanyTypeId('');
        setTempStateId('');
        setTempCityId('');
        setTempDistrictId('');
        setActiveFilters({});

        setSearchParams({});

        navigate('/PanelDeControl', { replace: true });
    };

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
        if (!isMobileMenuOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    };

    const toggleFiltersMobile = () => {
        setShowFiltersMobile(!showFiltersMobile);
        if (!showFiltersMobile) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    };

    useEffect(() => {
        loadUserData();
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [loadUserData]);

    function exportDashboardDataToCSV() {
        const rawData = JSON.parse(localStorage.getItem('dashboardData')) || {};
        const { central = {}, right = {} } = rawData;

        const formatLabel = (text) => {
            if (!text) return '';
            return text.replace(/_/g, ' ');
        };

        const processSection = (sectionData, sectionName) => {
            const isGroupedByTerm = Array.isArray(Object.values(sectionData)[0]);

            const transformData = (groupKey, groupData) => {
                const result = [];
                for (const [date, entries] of Object.entries(groupData)) {
                    entries.forEach(entry => {
                        result.push({
                            ...entry,
                            date_response: formatDate4(date),
                            term: groupKey
                        });
                    });
                }
                return result;
            };

            const sectionResults = [];

            Object.entries(sectionData).forEach(([groupKey, groupData]) => {
                const data = isGroupedByTerm
                    ? groupData.map((entry) => ({
                        ...entry,
                        date_response: formatDate4(entry.date_response),
                    }))
                    : transformData(groupKey, groupData);

                data.forEach(item => {
                    sectionResults.push({
                        'Nombre del Indicador': formatLabel(item.indicator || item.term),
                        'Resultado': convertNumberIntToDecimal(item.result) ?? '',
                        'Fecha de Respuesta': item.date_response || '',
                        'Unidad de medida': item.unit || '',
                    });
                });
            });

            return sectionResults;
        };

        const centralData = processSection(central, 'Central');
        const rightData = processSection(right, 'Right');

        const dataToExport = [...centralData, ...rightData];

        dataToExport.forEach(item => {
            Object.keys(item).forEach(key => {
                const newKey = `"${key}"`;
                if (newKey !== key) {
                    item[newKey] = item[key];
                    delete item[key];
                }
            });
        });

        // exportFromJSON({ data: dataToExport, fileName, exportType, withBOM: true });
        const wb = XLSX.utils.book_new();
        const wsData = XLSX.utils.json_to_sheet(dataToExport);

        // Ajustar ancho de columnas
        const colWidths = Object.keys(dataToExport[0]).map((key) => ({
            wch: Math.max(
                key.length,
                ...dataToExport.map((row) =>
                    row[key] ? row[key].toString().length : 0
                )
            ) + 2,
        }));
        wsData["!cols"] = colWidths;

        XLSX.utils.book_append_sheet(wb, wsData, "Datos del Proyecto");

        // 🔹 Nombre del archivo
        const fileName = `reporte_${new Date()
            .toISOString()
            .split("T")[0]}.xlsx`;

        // 🔹 Descargar archivo
        XLSX.writeFile(wb, fileName);
    }

    const getReport = async (data) => {
        let session = getSession();

        // console.log('getReport', data);

        let id = data.id.split('/')[0];
        let date = data.id.split('/')[1];
        let month = date.split('-')[0];
        let year = date.split('-')[1];

        let uri;

        if ([1, 6].includes(session.type_id)) {
            uri = `reports/export-report/${data.company.user_id}?month=${month}&year=${year}&project_id=${id}`;
        }

        if ([4, 5].includes(session.type_id)) {
            uri = `reports/export-report/${session.type_id === 4 ? session.id : session.company.user_id}?month=${month}&year=${year}&project_id=${id}`;
        }

        window.open(`${process.env.REACT_APP_API_URI}${uri}`, '_blank');
    };

    const exportProjectDataToExcel = () => {
        let session = getSession();
        let data = JSON.parse(localStorage.getItem('dashboardToProject')) || {};

        // console.log("Exporting project data to Excel for session:", session);

        try {
            Swal.fire({
                title: "Generando Excel",
                text: "Obteniendo y organizando datos...",
                icon: "info",
                allowOutsideClick: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading()
                },
            })

            if (!data || typeof data !== "object" || Object.keys(data).length === 0) {
                throw new Error("No se pudieron obtener los datos o los datos están vacíos")
            }

            let filteredData = data;

            if (session?.type_id === 4) {
                filteredData = data.filter(row => {
                    const rowCompanyId = row.Empresa;
                    return rowCompanyId == session.company.company_name;
                });

                // console.log(`Empresa ${session.id}: Filtrando datos, ${filteredData.length} registros de ${data.length} totales`);
            }

            if (filteredData.length < 1) {
                Swal.fire({
                    title: "Sin datos",
                    text: "No hay datos disponibles para exportar",
                    icon: "warning",
                    confirmButtonText: "Aceptar",
                    timer: 3000,
                })
                return;
            }

            const wb = XLSX.utils.book_new();
            const wsData = XLSX.utils.json_to_sheet(filteredData);

            const colWidths = Object.keys(filteredData[0]).map((key) => ({
                wch: Math.max(
                    key.length,
                    ...filteredData.map((row) =>
                        row[key] ? row[key].toString().length : 0
                    )
                ) + 2,
            }));
            wsData["!cols"] = colWidths;

            XLSX.utils.book_append_sheet(wb, wsData, "Datos de la empresa");

            let fileName;
            if (session?.type_id === 4) {
                fileName = `reporte_empresa_${session.id}_${new Date().toISOString().split("T")[0]}.xlsx`;
            } else {
                fileName = `reporte_completo_${new Date().toISOString().split("T")[0]}.xlsx`;
            }

            XLSX.writeFile(wb, fileName);

            Swal.fire({
                title: "Excel Generado",
                text: `Archivo exportado exitosamente con ${filteredData.length} registros`,
                icon: "success",
                confirmButtonText: "Aceptar",
                timer: 3000,
            });
        } catch (error) {
            Swal.fire({
                title: "Error",
                text: `No se pudo generar el archivo Excel: ${error.message}`,
                icon: "error",
                confirmButtonText: "Aceptar",
            })
        }
        return;
    };

    const exportChartsToPDF = async () => {
        // console.log('session', getSession());
        try {
            Swal.fire({
                title: "Generando Reporte PDF",
                text: "Obteniendo datos y preparando gráficos...",
                icon: "info",
                allowOutsideClick: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading()
                },
            })

            const companyName = companies.find((company) => company.id == idCompany)?.name || ""
            const projectName = projects.find((project) => project.id == idProject)?.name || ""
            const currentDate = new Date()

            const fileName = `reporte-${companyName.replace(/\s+/g, "-")}-${projectName.replace(/\s+/g, "-")}-${currentDate.toISOString().split("T")[0]}.pdf`;

            await exportMultipleChartsToPdf({ fileName });

            Swal.fire({
                title: "PDF Generado",
                text: "Reporte exportado exitosamente con gráficos",
                icon: "success",
                confirmButtonText: "Aceptar",
                timer: 3000,
            })
        } catch (error) {
            Swal.fire({
                title: "Error",
                text: "No se pudo generar el reporte PDF. Intente nuevamente.",
                icon: "error",
                confirmButtonText: "Aceptar",
            })
        }
    };

    useEffect(() => {
        getRibbon();
    }, []);

    return (
        <div className="flex flex-col lg:flex-row h-screen w-full overflow-hidden dark:bg-[#292929]">
            {/* Barra de navegación lateral - Siempre visible en desktop */}
            <nav
                id="Organización"
                className="hidden lg:flex lg:w-1/6 w-full h-full pt-7 pb-5 px-4 flex-col bg-white dark:bg-[#292929]"
            >
                <div className="flex flex-col h-full justify-between overflow-y-auto">
                    <div>
                        <div className="flex flex-row justify-start items-center pb-9">
                            <FontAwesomeIcon icon={faUserCircle} className="text-gray-500 dark:text-white text-2xl rounded-full w-9 h-9 p-1" />
                            <div className="p-1">
                                <span>
                                    <h1 className="text-sm font-medium dark:text-white">
                                        {userInfo.userName}
                                    </h1>
                                </span>
                                <span>
                                    <h1 className="text-xs dark:text-stone-400">{userInfo.role}</h1>
                                </span>
                            </div>
                        </div>
                        <div className="flex flex-col justify-center">
                            <Link to="/PanelDeControl">
                                <h1 className="text-xs font-medium flex items-end mb-1 w-full text-gray-500 bg-transparent py-2 px-2 rounded-lg cursor-pointer transition-colors dark:text-stone-400 hover:bg-turquesa hover:text-white">
                                    <FontAwesomeIcon icon={faChartPie} className="text-xl pr-2 dark:text-white" />
                                    Dashboard
                                </h1>
                            </Link>
                            {userInfo.role === "Administrador" && (
                                <Link to="/Organizaciones">
                                    <h1 className="text-xs font-medium flex items-end mb-1 w-full text-gray-500 bg-transparent py-2 px-2 rounded-lg cursor-pointer transition-colors dark:text-stone-400 hover:bg-turquesa hover:text-white">
                                        <FontAwesomeIcon icon={faBuilding} className="text-xl pr-2 dark:text-white" />
                                        Empresas o entidades
                                    </h1>
                                </Link>
                            )}

                            {userInfo.role === "Organización" && (
                                <Link to="/Empleados">
                                    <h1 className="text-xs font-medium flex items-end mb-1 w-full text-gray-500 bg-transparent py-2 px-2 rounded-lg cursor-pointer transition-colors dark:text-stone-400 hover:bg-turquesa hover:text-white">
                                        <FontAwesomeIcon icon={faBuilding} className="text-xl pr-2 dark:text-white" />
                                        Usuarios
                                    </h1>
                                </Link>
                            )}
                            <Link to="/Reportes">
                                <h1 className="text-xs font-medium flex items-end mb-1 w-full text-gray-500 bg-transparent py-2 px-2 rounded-lg cursor-pointer transition-colors dark:text-stone-400 hover:bg-turquesa hover:text-white">
                                    <FontAwesomeIcon icon={faFolder} className="text-xl pr-2 dark:text-white" />
                                    Reportes
                                </h1>
                            </Link>
                            {userInfo.role === "Administrador" && (
                                <>
                                    {/* <Link to="/CompararProyectos">
                                        <h1 className="text-xs font-medium flex items-end mb-1 w-full text-gray-500 bg-transparent py-2 px-2 rounded-lg cursor-pointer transition-colors dark:text-stone-400 hover:bg-turquesa hover:text-white">
                                            <FontAwesomeIcon icon={faChartBar} className="text-xl pr-2 dark:text-white" />
                                            Estadísticas de proyectos
                                        </h1>
                                    </Link> */}
                                    {/* <Link to="/DashboardV2">
                                        <h1 className="text-xs font-medium flex items-end mb-1 w-full text-gray-500 bg-transparent py-2 px-2 rounded-lg cursor-pointer transition-colors dark:text-stone-400 hover:bg-turquesa hover:text-white">
                                            <FontAwesomeIcon icon={faChartBar} className="text-xl pr-2 dark:text-white" />
                                            DashboardV2
                                        </h1>
                                    </Link> */}
                                </>
                            )}
                        </div>
                    </div>
                    <div className="flex flex-col justify-start">
                        {[4].includes(getSession()?.type_id) && (
                            <Link
                                to="/PerfilDeLaOrganizacion"
                                className="text-xs font-medium items-end mb-1 w-full text-gray-500 bg-transparent py-2 px-2 rounded-lg cursor-pointer transition-colors dark:text-stone-400 hover:bg-orange-500 hover:text-white"
                            >
                                <FontAwesomeIcon icon={faCog} className="text-xl pr-2 dark:text-white" />
                                Ajustes
                            </Link>
                        )}
                        <button
                            type="button"
                            className="text-start"
                            onClick={handleLogout}
                        >
                            <h1 className="text-xs font-medium items-end mb-1 w-full text-gray-500 bg-transparent py-2 px-2 rounded-lg cursor-pointer transition-colors dark:text-stone-400 hover:bg-red-500 hover:text-white">
                                <FontAwesomeIcon icon={faSignOutAlt} className="text-xl pr-2 dark:text-white" />
                                Cerrar sesión
                            </h1>
                        </button>
                    </div>
                </div>
            </nav>

            {/* Sección principal */}
            <section
                id="Graficos"
                className={`${panel && isPanelVisible ? "lg:w-5/6" : "lg:w-5/6"} w-full bg-slate-200 dark:bg-[#1e1e1e] flex flex-col overflow-hidden`}
            >
                {(fileName && (location.pathname !== '/AgregarReporte' && !location.pathname.startsWith('/EditarReporte/'))) && <div className="flex-row flex-wrap w-full justify-center items-center gap-2 hidden lg:flex p-6">
                    <div className="w-auto px-1 py-3 bg-white rounded-lg">
                        <img
                            src={`${process.env.REACT_APP_PHOTO_URI}photo/ribbon/image/${fileName}`}
                            className="w-full object-contain"
                            alt=""
                        />
                    </div>
                </div>}
                <div className="flex items-center justify-between bg-slate-200 dark:bg-[#1e1e1e]">
                    <button
                        className="px-2 text-gray-500 lg:hidden"
                        onClick={toggleMobileMenu}
                    >
                        <FontAwesomeIcon icon={faBars} className="text-2xl" />
                    </button>


                    {panel && (
                        <div className='flex justify-between w-full p-4'>
                            <button
                                className="p-2 text-gray-500 lg:hidden"
                                onClick={toggleFiltersMobile}
                            >
                                <FontAwesomeIcon icon={faFilter} className="text-2xl" />
                            </button>
                            {/* <button
                                className="px-3 py-1 bg-turquesa dark:bg-gray-600 text-white dark:text-white text-sm rounded hidden lg:block cursor-pointer"
                                onClick={togglePanelVisibility}
                            >
                                {isPanelVisible ? "Ocultar filtros" : "Mostrar filtros"}
                            </button> */}
                        </div>
                    )}
                </div>
                <div className={`flex-1 ${(!location.pathname.startsWith("/AgregarReporte") && !location.pathname.startsWith("/EditarReporte")) ? 'overflow-y-auto' : ''} p-4 relative`}>
                    {children}
                </div>
            </section>

            {/* Panel derecho de filtros */}
            {/* {panel && (isPanelVisible || showFiltersMobile) && (
                <section
                    id="Reportes"
                    className={`lg:w-2/6 w-full flex flex-col bg-white dark:bg-[#292929] overflow-hidden border-l border-gray-200 dark:border-gray-700
                               ${showFiltersMobile ? 'fixed flex inset-0 z-50 lg:relative' : 'hidden lg:flex'}`}
                >
                    {showFiltersMobile && (
                        <div className="flex justify-end p-2 lg:hidden">
                            <button
                                className="p-2 text-gray-500"
                                onClick={toggleFiltersMobile}
                            >
                                <FontAwesomeIcon icon={faX} className="text-xl" />
                            </button>
                        </div>
                    )}
                    <div className="overflow-y-auto flex-1 p-4">
                        <div className="w-full px-2 flex flex-col gap-2 mb-5">
                            <button
                                onClick={() => idProject ? exportProjectDataToExcel() : exportDashboardDataToCSV()}
                                className="px-3 py-2 bg-green-600 text-white text-sm rounded hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                📊 Exportar a Excel
                            </button>
                            <button
                                onClick={exportChartsToPDF}
                                className="px-3 py-2 bg-blue-600 text-white text-sm rounded hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                📈 Exportar Gráficos (PDF)
                            </button>
                        </div>
                        {[1, 4, 6].includes(getSession()?.type_id) && (
                            <div className="w-full px-2 space-y-4">
                                {[1].includes(getSession()?.type_id) && <SelectMultiple
                                    name="company_id"
                                    loading={loading}
                                    array={companies}
                                    label="Dashboard por empresa"
                                    isMulti={false}
                                    value={Number(idCompany) ?? ""}
                                    onChange={(e) => {
                                        navigate(`/PanelDeControlEmpresa/${e}`);
                                    }}
                                    placeholder="Seleccione una empresa"
                                />}

                                <SelectMultiple
                                    name="projects"
                                    loading={loading}
                                    array={projects}
                                    label="Dashboard por proyecto"
                                    isMulti={false}
                                    value={Number(idProject) ?? ""}
                                    onChange={handleProjectChange}
                                    placeholder="Seleccione un proyecto"
                                />

                                {[1, 6].includes(getSession()?.type_id) && <SelectMultiple
                                    name="sector"
                                    loading={loading}
                                    array={filters.sectors}
                                    label="Filtrar por sector"
                                    isMulti={false}
                                    value={Number(tempSectorId)}
                                    onChange={(value) => setTempSectorId(value)}
                                    placeholder="Seleccione un sector"
                                />}

                                {[1, 6].includes(getSession()?.type_id) && <SelectMultiple
                                    name="companyType"
                                    loading={loading}
                                    array={filters.companyTypes}
                                    label="Filtrar por tipo de empresa"
                                    isMulti={false}
                                    value={Number(tempCompanyTypeId)}
                                    onChange={(value) => setTempCompanyTypeId(value)}
                                    placeholder="Seleccione un tipo de empresa"
                                />}

                                {[1, 6].includes(getSession()?.type_id) && <SelectMultiple
                                    name="state"
                                    loading={loading}
                                    array={filters.states}
                                    label="Filtrar por departamento"
                                    isMulti={false}
                                    value={Number(tempStateId)}
                                    onChange={(value) => handleStateChange(value)}
                                    placeholder="Seleccione un departamento"
                                />}

                                {tempStateId && [1, 6].includes(getSession()?.type_id) && (
                                    <SelectMultiple
                                        name="city"
                                        loading={loading}
                                        array={filters.cities}
                                        label="Filtrar por municipio"
                                        isMulti={false}
                                        value={Number(tempCityId)}
                                        onChange={(value) => handleCityChange(value)}
                                        placeholder="Seleccione un municipio"
                                    />
                                )}

                                {tempCityId && [1, 6].includes(getSession()?.type_id) && (
                                    <SelectMultiple
                                        name="district"
                                        loading={loading}
                                        array={filters.districts}
                                        label="Filtrar por distrito"
                                        isMulti={false}
                                        value={Number(tempDistrictId)}
                                        onChange={(value) => setTempDistrictId(value)}
                                        placeholder="Seleccione un distrito"
                                    />
                                )}

                                <div className="mt-4">
                                    <label className="block text-sm font-medium mb-1 dark:text-white">
                                        <FontAwesomeIcon icon={faCalendarAlt} className="mr-2" />
                                        Filtrar por fecha
                                    </label>

                                    <div className="flex space-x-4 mb-3">
                                        <label className="inline-flex items-center">
                                            <input
                                                type="radio"
                                                className="form-radio"
                                                name="dateType"
                                                value="single"
                                                checked={tempDateType === 'single'}
                                                onChange={() => setTempDateType('single')}
                                            />
                                            <span className="ml-2 dark:text-white">Fecha única</span>
                                        </label>
                                        <label className="inline-flex items-center">
                                            <input
                                                type="radio"
                                                className="form-radio"
                                                name="dateType"
                                                value="range"
                                                checked={tempDateType === 'range'}
                                                onChange={() => setTempDateType('range')}
                                            />
                                            <span className="ml-2 dark:text-white">Rango de fechas</span>
                                        </label>
                                    </div>

                                    {tempDateType === 'single' && (
                                        <div className="grid grid-cols-2 gap-2">
                                            <div>
                                                <select
                                                    value={tempSelectedMonth}
                                                    onChange={(e) => setTempSelectedMonth(e.target.value)}
                                                    className="w-full p-2 text-sm border rounded dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                                                >
                                                    <option value="">Seleccione mes</option>
                                                    {months.map((month) => (
                                                        <option key={month.value} value={month.value}>
                                                            {month.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div>
                                                <select
                                                    value={tempSelectedYear}
                                                    onChange={(e) => setTempSelectedYear(e.target.value)}
                                                    className="w-full p-2 text-sm border rounded dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                                                >
                                                    <option value="">Seleccione año</option>
                                                    {generateYears().map((year) => (
                                                        <option key={year} value={year}>
                                                            {year}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    )}

                                    {tempDateType === 'range' && (
                                        <div className="space-y-2">
                                            <div className="grid grid-cols-2 gap-2">
                                                <div>
                                                    <select
                                                        value={tempRangeStartMonth}
                                                        onChange={(e) => setTempRangeStartMonth(e.target.value)}
                                                        className="w-full p-2 text-sm border rounded dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                                                    >
                                                        <option value="">Mes inicio</option>
                                                        {months.map((month) => (
                                                            <option key={`start-${month.value}`} value={month.value}>
                                                                {month.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div>
                                                    <select
                                                        value={tempRangeStartYear}
                                                        onChange={(e) => setTempRangeStartYear(e.target.value)}
                                                        className="w-full p-2 text-sm border rounded dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                                                    >
                                                        <option value="">Año inicio</option>
                                                        {generateYears().map((year) => (
                                                            <option key={`start-${year}`} value={year}>
                                                                {year}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="grid grid-cols-2 gap-2">
                                                <div>
                                                    <select
                                                        value={tempRangeEndMonth}
                                                        onChange={(e) => setTempRangeEndMonth(e.target.value)}
                                                        className="w-full p-2 text-sm border rounded dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                                                    >
                                                        <option value="">Mes fin</option>
                                                        {months.map((month) => (
                                                            <option key={`end-${month.value}`} value={month.value}>
                                                                {month.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div>
                                                    <select
                                                        value={tempRangeEndYear}
                                                        onChange={(e) => setTempRangeEndYear(e.target.value)}
                                                        className="w-full p-2 text-sm border rounded dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                                                    >
                                                        <option value="">Año fin</option>
                                                        {generateYears().map((year) => (
                                                            <option key={`end-${year}`} value={year}>
                                                                {year}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <div className="flex justify-between mt-3">
                                        <button
                                            onClick={applyDateFilters}
                                            disabled={
                                                !(
                                                    (tempDateType === 'single' && (tempSelectedMonth || tempSelectedYear)) ||
                                                    (tempDateType === 'range' && (tempRangeStartMonth || tempRangeStartYear || tempRangeEndMonth || tempRangeEndYear)) ||
                                                    tempSectorId ||
                                                    tempCompanyTypeId ||
                                                    tempStateId ||
                                                    tempCityId ||
                                                    (tempDistrictId && [1, 6].includes(getSession()?.type_id))
                                                )
                                            }
                                            className="px-3 py-1 bg-turquesa text-white text-sm rounded hover:bg-darkTurquesa disabled:opacity-50 disabled:cursor-not-allowed"
                                        >
                                            Aplicar filtros
                                        </button>
                                        <button
                                            onClick={clearFilters}
                                            className="px-3 py-1 bg-gray-300 text-gray-700 text-sm rounded hover:bg-gray-400 dark:bg-gray-600 dark:text-white"
                                        >
                                            Limpiar filtros
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        <h1 className="px-2 text-sm font-medium dark:text-white mt-5">Últimos reportes</h1>
                        <div className="h-2/5 mb-8 overflow-y-auto">
                            {loading ? (
                                [1, 2, 3, 4, 5].map((item, index) => (
                                    <div key={index} className="bg-gray-200 dark:bg-gray-200 rounded-lg m-2 flex flex-row justify-between items-center animate-pulse">
                                        <div className="p-2">
                                            <div className="h-4 bg-gray-100 dark:bg-gray-400 rounded w-1/4 mb-1"></div>
                                            <div className="h-3 bg-gray-100 dark:bg-gray-400 rounded w-full"></div>
                                        </div>
                                        <div className="flex space-x-2 p-2">
                                            <div className="h-6 w-6 bg-gray-100 dark:bg-gray-400 rounded"></div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                reports.length > 0 ? (
                                    reports.map((report, index) => (
                                        <div
                                            onClick={() => getReport(report)}
                                            key={index}
                                            className="bg-slate-100 dark:bg-[#292929] rounded-lg m-2 flex flex-row justify-between items-center transition-colors hover:bg-slate-300 cursor-pointer"
                                        >
                                            <div className="p-2">
                                                <h1 className="text-sm font-semibold dark:text-white">
                                                    Reporte de {report.report_created_date}
                                                </h1>
                                                <p className="text-xs text-gray-500 dark:text-stone-400">
                                                    Reporte {report.id}
                                                </p>
                                            </div>
                                            <div className="flex space-x-2 p-2">
                                                <FontAwesomeIcon icon={faEye} className="text-turquesa text-lg" />
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="bg-slate-100 dark:bg-[#292929] rounded-lg m-2 flex flex-row justify-between items-center cursor-pointer transition-colors hover:bg-slate-300">
                                        <div className="p-2">
                                            <h1 className="text-sm font-semibold dark:text-white">
                                                No hay reportes
                                            </h1>
                                            <p className="text-xs text-gray-500 dark:text-stone-400">
                                                No se han registrado reportes en la plataforma
                                            </p>
                                        </div>
                                    </div>
                                )
                            )}
                        </div>

                        <div className='mt-5 p-5'>
                            <ChartComponent rawData={resultsGrouped} />
                        </div>
                    </div>
                </section>
            )} */}

            {/* Menú móvil */}
            {isMobileMenuOpen && (
                <div className="fixed inset-0 z-50 bg-white dark:bg-[#292929] lg:hidden">
                    <div className="flex justify-end p-4">
                        <button
                            className="p-2 text-gray-500"
                            onClick={() => setIsMobileMenuOpen(false)}
                        >
                            <FontAwesomeIcon icon={faX} className="text-xl" />
                        </button>
                    </div>
                    <div className="flex flex-col lg:h-full justify-between overflow-y-auto p-4">
                        <div>
                            <div className="flex flex-row justify-start items-center pb-9">
                                <FontAwesomeIcon icon={faUserCircle} className="text-gray-500 dark:text-white text-2xl rounded-full w-9 h-9 p-1" />
                                <div className="p-1">
                                    <span>
                                        <h1 className="text-sm font-medium dark:text-white">
                                            {userInfo.userName}
                                        </h1>
                                    </span>
                                    <span>
                                        <h1 className="text-xs dark:text-stone-400">{userInfo.role}</h1>
                                    </span>
                                </div>
                            </div>
                            <div className="flex flex-col justify-center">
                                <Link to="/PanelDeControl" onClick={() => setIsMobileMenuOpen(false)}>
                                    <h1 className="text-xs font-medium flex items-end mb-1 w-full text-gray-500 bg-transparent py-2 px-2 rounded-lg cursor-pointer transition-colors dark:text-stone-400 hover:bg-turquesa hover:text-white">
                                        <FontAwesomeIcon icon={faChartPie} className="text-xl pr-2 dark:text-white" />
                                        Dashboard
                                    </h1>
                                </Link>
                                {userInfo.role === "Administrador" && (
                                    <Link to="/Organizaciones" onClick={() => setIsMobileMenuOpen(false)}>
                                        <h1 className="text-xs font-medium flex items-end mb-1 w-full text-gray-500 bg-transparent py-2 px-2 rounded-lg cursor-pointer transition-colors dark:text-stone-400 hover:bg-turquesa hover:text-white">
                                            <FontAwesomeIcon icon={faBuilding} className="text-xl pr-2 dark:text-white" />
                                            Empresas o entidades
                                        </h1>
                                    </Link>
                                )}

                                {userInfo.role === "Organización" && (
                                    <Link to="/Empleados" onClick={() => setIsMobileMenuOpen(false)}>
                                        <h1 className="text-xs font-medium flex items-end mb-1 w-full text-gray-500 bg-transparent py-2 px-2 rounded-lg cursor-pointer transition-colors dark:text-stone-400 hover:bg-turquesa hover:text-white">
                                            <FontAwesomeIcon icon={faBuilding} className="text-xl pr-2 dark:text-white" />
                                            Usuarios
                                        </h1>
                                    </Link>
                                )}
                                <Link to="/Reportes" onClick={() => setIsMobileMenuOpen(false)}>
                                    <h1 className="text-xs font-medium flex items-end mb-1 w-full text-gray-500 bg-transparent py-2 px-2 rounded-lg cursor-pointer transition-colors dark:text-stone-400 hover:bg-turquesa hover:text-white">
                                        <FontAwesomeIcon icon={faFolder} className="text-xl pr-2 dark:text-white" />
                                        Reportes
                                    </h1>
                                </Link>
                                {userInfo.role === "Administrador" && (
                                    <Link to="/CompararProyectos">
                                        <h1 className="text-xs font-medium flex items-end mb-1 w-full text-gray-500 bg-transparent py-2 px-2 rounded-lg cursor-pointer transition-colors dark:text-stone-400 hover:bg-turquesa hover:text-white">
                                            <FontAwesomeIcon icon={faChartBar} className="text-xl pr-2 dark:text-white" />
                                            Estadísticas de proyectos
                                        </h1>
                                    </Link>
                                )}
                            </div>
                        </div>
                        <div className="flex flex-col justify-start">
                            {[4].includes(getSession()?.type_id) && (
                                <Link
                                    to="/PerfilDeLaOrganizacion"
                                    className="text-xs font-medium items-end mb-1 w-full text-gray-500 bg-transparent py-2 px-2 rounded-lg cursor-pointer transition-colors dark:text-stone-400 hover:bg-orange-500 hover:text-white"
                                    onClick={() => setIsMobileMenuOpen(false)}
                                >
                                    <FontAwesomeIcon icon={faCog} className="text-xl pr-2 dark:text-white" />
                                    Ajustes
                                </Link>
                            )}
                            <button
                                type="button"
                                className="text-start"
                                onClick={handleLogout}
                            >
                                <h1 className="text-xs font-medium items-end mb-1 w-full text-gray-500 bg-transparent py-2 px-2 rounded-lg cursor-pointer transition-colors dark:text-stone-400 hover:bg-red-500 hover:text-white">
                                    <FontAwesomeIcon icon={faSignOutAlt} className="text-xl pr-2 dark:text-white" />
                                    Cerrar sesión
                                </h1>
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default MainThemeLayout;